export default {
  title: '',
  description: '',
}
